"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
Object.defineProperty(exports, "__esModule", {
  value: true
});
var event_1 = require("./event");
var utils_1 = require("./utils");
var SdkStarted = /** @class */function (_super) {
  __extends(SdkStarted, _super);
  function SdkStarted() {
    var _this = _super.call(this, "sdkStarted", {
      location_href: "",
      query_string_params: {},
      notifications_enabled: "",
      navigator_app_code_name: "",
      navigator_app_name: "",
      navigator_app_version: "",
      navigator_cookie_enabled: false,
      navigator_product: ""
    }) || this;
    _this.prefab = true;
    _this.setLocationHref().setQueryStringParams().setNotificationsEnabled().setNavigatorAppCodeName().setNavigatorAppName().setNavigatorAppVersion().setNavigatorCookieEnabled().setNavigatorProduct().setScreen().setLanguage();
    _this.prefab = true;
    return _this;
  }
  SdkStarted.prototype.setQueryStringParams = function () {
    if (utils_1.default.isClient()) {
      this.getEventBody().getJson().query_string_params = utils_1.default.getQueryStringParams(window.location.search);
    }
    return this;
  };
  SdkStarted.prototype.setLocationHref = function () {
    if (utils_1.default.isClient()) {
      this.getEventBody().getJson().location_href = window.location.href;
    }
    return this;
  };
  SdkStarted.prototype.setLanguage = function () {
    if (window.navigator.language) {
      this.getEventBody().getJson().lang = navigator.language;
    }
    return this;
  };
  SdkStarted.prototype.setNotificationsEnabled = function () {
    if (utils_1.default.isClient()) {
      if (typeof Notification !== "undefined") {
        this.getEventBody().getJson().notifications_enabled = Notification.permission;
      }
    }
    return this;
  };
  SdkStarted.prototype.setNavigatorAppCodeName = function () {
    if (utils_1.default.isClient()) {
      if (navigator && typeof navigator.appCodeName !== "undefined") {
        this.getEventBody().getJson().navigator_app_code_name = navigator.appCodeName;
      }
    }
    return this;
  };
  SdkStarted.prototype.setNavigatorAppName = function () {
    if (utils_1.default.isClient()) {
      if (navigator && typeof navigator.appName !== "undefined") {
        this.getEventBody().getJson().navigator_app_name = navigator.appName;
      }
    }
    return this;
  };
  SdkStarted.prototype.setNavigatorAppVersion = function () {
    if (utils_1.default.isClient()) {
      if (navigator && typeof navigator.appVersion !== "undefined") {
        this.getEventBody().getJson().navigator_app_version = navigator.appVersion;
      }
    }
    return this;
  };
  SdkStarted.prototype.setNavigatorCookieEnabled = function () {
    if (utils_1.default.isClient()) {
      this.getEventBody().getJson().navigator_cookie_enabled = navigator.cookieEnabled;
    }
    return this;
  };
  SdkStarted.prototype.setNavigatorProduct = function () {
    if (utils_1.default.isClient()) {
      if (navigator && typeof navigator.product !== "undefined") {
        this.getEventBody().getJson().navigator_product = navigator.product;
      }
    }
    return this;
  };
  SdkStarted.prototype.setScreen = function () {
    if (utils_1.default.isClient()) {
      var screen_1 = typeof window.screen !== "undefined" ? {
        height: window.screen.height,
        width: window.screen.width
      } : {};
      this.getEventBody().getJson().screen = screen_1;
    }
    return this;
  };
  SdkStarted.prototype._isPrefab = function () {
    return true;
  };
  return SdkStarted;
}(event_1.default);
exports.default = SdkStarted;